import { render, staticRenderFns } from "./TrackAndTraceColumn.vue?vue&type=template&id=2d399fcb&scoped=true&"
import script from "./TrackAndTraceColumn.vue?vue&type=script&lang=js&"
export * from "./TrackAndTraceColumn.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTraceColumn.vue?vue&type=style&index=0&id=2d399fcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d399fcb",
  null
  
)

export default component.exports